import { AnalyticsEventType as n } from "@modernhealth/analytics-core";
const t = (e) => ({
  eventName: "circles: registration form refetched",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), s = () => ({
  eventName: "circles: registration form failed to load",
  eventType: n.ERROR,
  eventProperties: {
    eventSource: "lexicon-package"
  }
}), o = (e) => ({
  eventName: "circles: banner cta",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), a = () => ({
  eventName: "circles: reload explore series",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package"
  }
}), c = () => ({
  eventName: "circles: explore series failed to load",
  eventType: n.ERROR,
  eventProperties: {
    eventSource: "lexicon-package"
  }
}), i = (e) => ({
  eventName: "circles: change language",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), r = (e) => ({
  eventName: "back",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), v = (e) => ({
  eventName: "providers: match with a provider",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), p = (e) => ({
  eventName: "providers: choose your provider intro screen",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), l = (e) => ({
  eventName: "schedule session calendar: book a session",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), m = (e) => ({
  eventName: "schedule session calendar: confirm session",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), g = (e) => ({
  eventName: "assessment employment_health_althoughsick",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), P = (e) => ({
  eventName: "assessment employment_health_burnedout",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), k = (e) => ({
  eventName: "assessment employment_health_sickness",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), S = (e) => ({
  eventName: "assessment gad_nervous",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), C = (e) => ({
  eventName: "assessment gad_worrying",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), d = (e) => ({
  eventName: "assessment gad_afraid",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), u = (e) => ({
  eventName: "assessment gad_annoyed",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), y = (e) => ({
  eventName: "assessment gad_relaxing",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), L = (e) => ({
  eventName: "assessment gad_restless",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), N = (e) => ({
  eventName: "assessment gad_worryingdifferentthings",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), h = (e) => ({
  eventName: "assessment phq_feelingdown",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), x = (e) => ({
  eventName: "assessment phq_littleinterest",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), _ = (e) => ({
  eventName: "assessment phq_appetite",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), T = (e) => ({
  eventName: "assessment phq_concentrating",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), I = (e) => ({
  eventName: "assessment phq_feelingbad",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), A = (e) => ({
  eventName: "assessment phq_moving",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), w = (e) => ({
  eventName: "assessment phq_selfharm",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), E = (e) => ({
  eventName: "assessment phq_sleep",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), F = (e) => ({
  eventName: "assessment phq_tired",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), G = (e) => ({
  eventName: "assessment who5_activevigorous",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), K = (e) => ({
  eventName: "assessment who5_calmrelaxed",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), W = (e) => ({
  eventName: "assessment who5_freshrested",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), O = (e) => ({
  eventName: "assessment who5_goodspirits",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), f = (e) => ({
  eventName: "assessment who5_interestme",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), q = (e) => ({
  eventName: "video session rating questions",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), R = (e) => ({
  eventName: "confirm direct therapy access",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), b = (e) => ({
  eventName: "homepage: crisis support",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), H = (e) => ({
  eventName: "homepage: hero: daily pause",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), M = (e) => ({
  eventName: "view all",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), B = (e) => ({
  eventName: "circles: membership check",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), D = (e) => ({
  eventName: "on demand video link",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), V = (e) => ({
  eventName: "homepage: 1care: card",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), j = (e) => ({
  eventName: "content",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), Q = (e) => ({
  eventName: "Insights Hub: Applied Filter",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), z = (e) => ({
  eventName: "Insights Hub: Clicked on Report",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), J = (e) => ({
  eventName: "admin portal navigation bar",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), Y = () => ({
  eventName: "add new admin",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package"
  }
}), U = (e) => ({
  eventName: "invite new admin",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), X = (e) => ({
  eventName: "edit admin",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), Z = () => ({
  eventName: "remove admin",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package"
  }
}), $ = (e) => ({
  eventName: "save admin role change",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ee = (e) => ({
  eventName: "admin portal card",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ne = (e) => ({
  eventName: "admin portal featured highlight",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), te = (e) => ({
  eventName: "join session",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), se = (e) => ({
  eventName: "cancel session",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), oe = (e) => ({
  eventName: "cancel session confirmation",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ae = (e) => ({
  eventName: "manage care team navigation",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ce = (e) => ({
  eventName: "end pathway confirmation",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ie = (e) => ({
  eventName: "pathways learn more",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), re = (e) => ({
  eventName: "explore pathways",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ve = (e) => ({
  eventName: "create pathway",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), pe = (e) => ({
  eventName: "start pathway",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), le = (e) => ({
  eventName: "schedule a session",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), me = (e) => ({
  eventName: "view session",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ge = () => ({
  eventName: "view provider profile",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package"
  }
}), Pe = (e) => ({
  eventName: "pathway recommended activity",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ke = (e) => ({
  eventName: "pathway rating question",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), Se = (e) => ({
  eventName: "pathway assessment question",
  eventType: n.SINGLE_PAGE_FLOW,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), Ce = (e) => ({
  eventName: "start pathways assessment",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), de = (e) => ({
  eventName: "circles: submit registration form",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ue = (e) => ({
  eventName: "client drawer details",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), ye = () => ({
  eventName: "pathway assessment",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package"
  }
}), Le = (e) => ({
  eventName: "guest login",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), Ne = (e) => ({
  eventName: "admin resource",
  eventType: n.CLICK,
  eventProperties: {
    eventSource: "lexicon-package",
    ...e
  }
}), xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clickCirclesRegistrationFormRefetched: t,
  errorCirclesRegistrationFormFailedToLoad: s,
  clickCirclesBannerCta: o,
  clickCirclesReloadExploreSeries: a,
  errorCirclesExploreSeriesFailedToLoad: c,
  clickCirclesChangeLanguage: i,
  clickBack: r,
  clickProvidersMatchWithAProvider: v,
  clickProvidersChooseYourProviderIntroScreen: p,
  clickScheduleSessionCalendarBookASession: l,
  clickScheduleSessionCalendarConfirmSession: m,
  singlePageFlowAssessmentEmploymentHealthAlthoughsick: g,
  singlePageFlowAssessmentEmploymentHealthBurnedout: P,
  singlePageFlowAssessmentEmploymentHealthSickness: k,
  singlePageFlowAssessmentGadNervous: S,
  singlePageFlowAssessmentGadWorrying: C,
  singlePageFlowAssessmentGadAfraid: d,
  singlePageFlowAssessmentGadAnnoyed: u,
  singlePageFlowAssessmentGadRelaxing: y,
  singlePageFlowAssessmentGadRestless: L,
  singlePageFlowAssessmentGadWorryingdifferentthings: N,
  singlePageFlowAssessmentPhqFeelingdown: h,
  singlePageFlowAssessmentPhqLittleinterest: x,
  singlePageFlowAssessmentPhqAppetite: _,
  singlePageFlowAssessmentPhqConcentrating: T,
  singlePageFlowAssessmentPhqFeelingbad: I,
  singlePageFlowAssessmentPhqMoving: A,
  singlePageFlowAssessmentPhqSelfharm: w,
  singlePageFlowAssessmentPhqSleep: E,
  singlePageFlowAssessmentPhqTired: F,
  singlePageFlowAssessmentWho5Activevigorous: G,
  singlePageFlowAssessmentWho5Calmrelaxed: K,
  singlePageFlowAssessmentWho5Freshrested: W,
  singlePageFlowAssessmentWho5Goodspirits: O,
  singlePageFlowAssessmentWho5Interestme: f,
  singlePageFlowVideoSessionRatingQuestions: q,
  clickConfirmDirectTherapyAccess: R,
  clickHomepageCrisisSupport: b,
  clickHomepageHeroDailyPause: H,
  clickViewAll: M,
  clickCirclesMembershipCheck: B,
  clickOnDemandVideoLink: D,
  clickHomepage1CareCard: V,
  clickContent: j,
  clickInsightsHubAppliedFilter: Q,
  clickInsightsHubClickedOnReport: z,
  clickAdminPortalNavigationBar: J,
  clickAddNewAdmin: Y,
  clickInviteNewAdmin: U,
  clickEditAdmin: X,
  clickRemoveAdmin: Z,
  clickSaveAdminRoleChange: $,
  clickAdminPortalCard: ee,
  clickAdminPortalFeaturedHighlight: ne,
  clickJoinSession: te,
  clickCancelSession: se,
  clickCancelSessionConfirmation: oe,
  clickManageCareTeamNavigation: ae,
  clickEndPathwayConfirmation: ce,
  clickPathwaysLearnMore: ie,
  clickExplorePathways: re,
  clickCreatePathway: ve,
  clickStartPathway: pe,
  clickScheduleASession: le,
  clickViewSession: me,
  clickViewProviderProfile: ge,
  clickPathwayRecommendedActivity: Pe,
  singlePageFlowPathwayRatingQuestion: ke,
  singlePageFlowPathwayAssessmentQuestion: Se,
  clickStartPathwaysAssessment: Ce,
  clickCirclesSubmitRegistrationForm: de,
  clickClientDrawerDetails: ue,
  clickPathwayAssessment: ye,
  clickGuestLogin: Le,
  clickAdminResource: Ne
}, Symbol.toStringTag, { value: "Module" }));
export {
  xe as EventLexicon
};
//# sourceMappingURL=analytics-lexicon.es.js.map
